import { useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";

const useStartPageCachedData = (scope, startPageFilters) => {
  const queryClient = useQueryClient();

  const cachedAssistances = queryClient.getQueryData(["openedOrFinished", scope?.id]) || {
    finishedData: [],
    openedData: [],
  };

  const cachedAppointments = queryClient.getQueryData(["appointmentsData", scope?.id]) || [];

  const search = startPageFilters?.search?.trim().toLowerCase();

  const filterFn = (item) =>
    item.userNames?.some((user) =>
      String(user?.name || "").toLowerCase().includes(search || "")
    );

  const filteredAssistances = useMemo(() => {
    if (!search) return cachedAssistances;

    return {
      finishedData: cachedAssistances.finishedData.filter(filterFn),
      openedData: cachedAssistances.openedData.filter(filterFn),
    };
  }, [cachedAssistances, search]);

  const filteredAppointments = useMemo(() => {
    if (!search) return cachedAppointments;
    return cachedAppointments.filter(filterFn);
  }, [cachedAppointments, search]);

  return {
    openedData: filteredAssistances.openedData,
    finishedData: filteredAssistances.finishedData,
    appointmentsData: filteredAppointments,
  };
};

export default useStartPageCachedData;
